<template>
  <div>
    <a-alert message="Informational" description="Our Dashboard is Coming Soon" type="info" showIcon />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KeuanganDashboard",
  computed: {
    ...mapGetters(["getScreen"])
  },
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
  }
};
</script>